var map = {
	"./partners1.jpg": "0a07",
	"./partners10.jpg": "3a77",
	"./partners11.jpg": "87a6",
	"./partners12.jpg": "4033",
	"./partners13.jpg": "8a03",
	"./partners14.jpg": "e828",
	"./partners15.jpg": "ce4b",
	"./partners2.jpg": "83cd",
	"./partners3.jpg": "3ff4",
	"./partners4.jpg": "4e69",
	"./partners5.jpg": "a587",
	"./partners6.jpg": "7542",
	"./partners7.jpg": "3ec6",
	"./partners8.jpg": "109d",
	"./partners9.jpg": "c119"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8584";